import jQuery from 'jquery'

export default class SolutionsBenefits {
  constructor(element) {
    if (!element) {
      return false
    }

    this.$element = jQuery(element)
    this.solutionsColumns = jQuery(
      '.s-solutions-benefits__solutions .column',
      this.$element
    )
    this.setEqualHeights()
    this.setHighlight()

    // resize
    jQuery(window).on('resize', () => {
      this.setEqualHeights()
    })
  }

  setHighlight() {
    jQuery('.s-solutions-benefits__solutions .column').hover(
      (e) => {
        const targetElement = jQuery(e.currentTarget)
        this.solutionsColumns.addClass('is-inactive')
        targetElement.removeClass('is-inactive').addClass('is-active')
      },
      (e) => {
        const targetElement = jQuery(e.currentTarget)
        this.solutionsColumns.removeClass('is-inactive')
        targetElement.removeClass('is-active')
      }
    )
  }

  removeAttrStyle() {
    jQuery('.cell', this.element).removeAttr('style')
  }

  setEqualHeights() {
    this.removeAttrStyle()

    jQuery('.s-solutions-benefits__attributes .cell').each(
      (indexRow, element) => {
        const highestBox = jQuery(element).height()

        jQuery('.s-solutions-benefits__solutions .column').each(
          (indexColumn, element) => {
            const elem = jQuery(element).find('.cell').eq(indexRow)
            elem.height(highestBox)
          }
        )
      }
    )
  }
}
